import { render } from "./xsjj.vue?vue&type=template&id=74594de2&scoped=true&ts=true"
import script from "./xsjj.vue?vue&type=script&lang=ts"
export * from "./xsjj.vue?vue&type=script&lang=ts"

import "./xsjj.vue?vue&type=style&index=0&id=74594de2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74594de2"]])

export default __exports__